module.exports = __webpack_public_path__ + "img/bsite.d33fecc7.svg";